import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const ItemPost = ({ slug, title, bodyContent, image, column, categories }) => {
  const { file: { url, fileName } } = { ...image }
  return (
    <div className={column}>
      <div className='firo-blog-entry layout-1 margin-bottom-35px'>
        <div className='img-in'>
          <img width='100%' height='100%' src={url} alt={fileName} />
        </div>
        <div className='cats'>
          {
            categories.map((category, index) => <Link key={index} to={`/category/${category.slug}`} className='title'>{category.name},&nbsp;</Link>)
          }
        </div>
        <Link to={`/post/${slug}`} className='title '>{title}</Link>
        <p className='truncate-text' dangerouslySetInnerHTML={{ __html: bodyContent.childMarkdownRemark.html }} />
        <Link to={`/post/${slug}`} className='read_more'>Read More</Link>
      </div>
    </div>
  )
}

ItemPost.propTypes = {
  column: PropTypes.string,
  slug: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  bodyContent: PropTypes.shape(),
  categories: PropTypes.arrayOf(PropTypes.shape()),
  image: PropTypes.shape()
}

ItemPost.defaultProps = {
  column: 'col-lg-6',
  slug: '',
  title: '',
  bodyContent: {},
  categories: [],
  image: {}
}

export default ItemPost
